//REDUX-TOOLKIT
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

// COMMISSION_WALLET
// PURCHASE_WALLET
interface State {
    totalBalance: any
    tokens: any
    assets: any
    growth: any
    withdrawHistory: any
    allTokens: any
    allNetworks: any
    allAddresses: any
    transactionHistory: any
    migrationHistory: any
    topupHistory: any
    walletPrioritySetting: any
    xplWalletDetails: any
    coinsBalance: any
    registrationStatus: any
    unlockLoading: boolean
    claimLoading?: boolean
    addressValidationLoading?: boolean
    addressValidation?: any
}

const initialState: State = {
    totalBalance: null,
    tokens: null,
    assets: null,
    growth: null,
    withdrawHistory: null,
    allTokens: null,
    allNetworks: null,
    allAddresses: null,
    transactionHistory: null,
    migrationHistory: null,
    topupHistory: null,
    walletPrioritySetting: null,
    xplWalletDetails: null,
    coinsBalance: null,
    registrationStatus: null,
    unlockLoading: false,
    claimLoading: false,
    addressValidationLoading: false,
    addressValidation: null,
}

const slice = createSlice({
    name: "wallet",
    initialState,
    reducers: {
        setWallet: (state, action: PayloadAction<any>) => {
            return { ...state, ...action.payload }
        },
        setAssets: (state, action: PayloadAction<any>) => {
            return { ...state, assets: action.payload }
        },
        setGrowth: (state, action: PayloadAction<any>) => {
            return { ...state, growth: action.payload }
        },
        setWithdrawHistory: (state, action: PayloadAction<any>) => {
            return { ...state, withdrawHistory: action.payload }
        },
        setTransactionHistory: (state, action: PayloadAction<any>) => {
            return { ...state, transactionHistory: action.payload }
        },
        setMigrationHistory: (state, action: PayloadAction<any>) => {
            return { ...state, migrationHistory: action.payload }
        },
        setTopupHistory: (state, action: PayloadAction<any>) => {
            return { ...state, topupHistory: action.payload }
        },
        setAllTokens: (state, action: PayloadAction<any>) => {
            return { ...state, allTokens: action.payload }
        },
        setAllNetworks: (state, action: PayloadAction<any>) => {
            return { ...state, allNetworks: action.payload }
        },
        setAllAddresses: (state, action: PayloadAction<any>) => {
            return { ...state, allAddresses: action.payload }
        },
        setWalletPrioritySetting: (state, action: PayloadAction<any>) => {
            return { ...state, walletPrioritySetting: action.payload }
        },
        setXplWalletDetails: (state, action: PayloadAction<any>) => {
            return { ...state, xplWalletDetails: action.payload }
        },
        setCoinsBalance: (state, action: PayloadAction<any>) => {
            return { ...state, coinsBalance: action.payload }
        },
        setRegistrationStatus: (state, action: PayloadAction<any>) => {
            return { ...state, registrationStatus: action.payload }
        },
        setUnlockLoading: (state, action: PayloadAction<boolean>) => {
            return { ...state, unlockLoading: action.payload }
        },
        setClaimLoading: (state, action: PayloadAction<boolean>) => {
            return { ...state, claimLoading: action.payload }
        },
        setAddressValidationLoading: (
            state,
            action: PayloadAction<boolean>
        ) => {
            return { ...state, addressValidationLoading: action.payload }
        },
        setAddressValidation: (state, action: PayloadAction<boolean>) => {
            return { ...state, addressValidation: action.payload }
        },
    },
})

export const {
    setAddressValidation,
    setWallet,
    setAssets,
    setGrowth,
    setWithdrawHistory,
    setAllTokens,
    setAllNetworks,
    setAllAddresses,
    setTransactionHistory,
    setMigrationHistory,
    setTopupHistory,
    setWalletPrioritySetting,
    setXplWalletDetails,
    setCoinsBalance,
    setRegistrationStatus,
    setUnlockLoading,
    setClaimLoading,
    setAddressValidationLoading,
} = slice.actions
export const selectWallet = (state: { wallet: State }) => state.wallet
export default slice.reducer
